import { Service } from 'typedi';
import { BaseViewModel } from '../../../../../core/services/BaseViewModel';
import { ISpcService } from '../../SpcService';
import { action, makeObservable, observable } from 'mobx';
import { Appl } from '../../../../../core/Appl';
import { SpcModel } from './EstimateDetailsModel';
import Helper, { toLocalDate } from '../../../../../core/services/Helper';

@Service() // eslint-disable-next-line
export default class EstimateDetailsViewModel extends BaseViewModel {
  private service: ISpcService;

  @observable public model: SpcModel = {
    submissionId: 0,
  };
  @observable public spcTypeSubId: number = 0; 
  constructor() {
    super();
    this.service = Appl.Services.get<ISpcService>('ISpcService');
    makeObservable(this);
  }

  @action
  public async initAsync(spcTypeSubId:string) {
    this.pageTitle = `Service Purchase Estimate #${spcTypeSubId}`;
    this.spcTypeSubId = Number(spcTypeSubId);
    const result = await this.service.getFinalEstimateAsync(this.spcTypeSubId);
      if (result.success) {
        this.model.finalEstimate = result.data;
        this.setToLocalDates();
       
      } else {
        Appl.Error.handle(result.error, true);
       
      }
  }

     private setToLocalDates(): void {
          
     this.model.estimateDetails?.map((estimate) => {
      if(estimate.startDate){
        estimate.startDate = toLocalDate(estimate.startDate);
      }
      if(estimate.endDate){
        estimate.endDate = toLocalDate(estimate.endDate);
      }
      if(estimate.withdrawDate){
        estimate.withdrawDate = toLocalDate(estimate.withdrawDate);
      }
      if(estimate.mbrEntryDate){
        estimate.mbrEntryDate = toLocalDate(estimate.mbrEntryDate); 
      }
      return estimate;
      });
  }

  @action
    public async onPrintEstimateAsync(): Promise<void> {
      const result = await this.service?.downloadAsync(`/spc/purchase-calculator/estimate-as-pdf/${this.spcTypeSubId}`);
      if (result.success) {
        Helper.downloadFile(result.data, `SPC-${this.spcTypeSubId}.pdf`, 'application/pdf');
      } else {
        Appl.Error.handle(result.error);
      }
   }
}
